export default __webpack_public_path__ + "static/media/TVS Sport 100 KLS catalogo 2021.35ad832a.pdf";